import { API, graphqlOperation } from "aws-amplify";
import React from "react";
import Loading from "../../../../../_shared/components/Loading/Loading";
import "../styles/InsiderAndCorrections.scss";

const currency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});
const number = new Intl.NumberFormat("en-US");
function InsiderAndCorrections(props) {
  const [data, setData] = React.useState({});
  const [insiderTransactions, setInsiderTransactions] = React.useState([]);
  React.useEffect(() => {
    refresh();
    if (props.insiderTransactions) {
      const insiderTransactions = props.insiderTransactions
        .replace(/,/g, "")
        .substr(7, props.insiderTransactions.length - 8)
        .split(";9;")
        .slice(1)
        .map((obj) => obj.split(/;1;|;12;|;12|;13;|;13/));

      const result = [];
      for (let i = 0; i < insiderTransactions.length; i++) {
        if (insiderTransactions[i].length < 3) {
          result.push(
            [insiderTransactions[i][0]].concat(insiderTransactions[i + 1]),
          );
          i++;
        } else result.push(insiderTransactions[i]);
      }
      setInsiderTransactions(result);
    }
    // eslint-disable-next-line
  }, []);
  const refresh = async () => {
    const response = (
      await API.graphql(
        graphqlOperation(`{
      get_usd_correlations_for_ticker_data(object: {ticker: "${props.value}"}) {
        data
      }
    }`),
      )
    ).data.get_usd_correlations_for_ticker_data.data;
    setData(response);
  };
  const percentColorVolume = (price) => {
    return price === 0
      ? "percent grey"
      : price < 0
      ? "percent red"
      : "percent green";
  };
  return (
    <div className="bottom-half">
      <div className="section3" style={{ overflowY: "scroll", maxHeight: 161 }}>
        {insiderTransactions.length === 0 ||
        insiderTransactions.filter((obj, i) => obj[1] !== " ").length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            No insider transactions available
          </div>
        ) : (
          <>
            {" "}
            <div className="inside-title">
              INSIDER TRANSACTIONS (LAST 12-MTH)
            </div>
            <div className="insider-table">
              <div className="insider-section" style={{ display: "flex" }}>
                <div
                  className="insider-header justify-center"
                  style={{ color: "#BBB8B8" }}
                >
                  Trade Date
                </div>
              </div>
              <div className="insider-section">
                <div
                  className="insider-header justify-center"
                  style={{ color: "#BBB8B8" }}
                >
                  Trade Type
                </div>
              </div>
              <div className="insider-section">
                <div
                  className="insider-header justify-center"
                  style={{ color: "#BBB8B8" }}
                >
                  Price
                </div>
              </div>
              <div className="insider-section">
                <div
                  className="insider-header justify-center"
                  style={{ color: "#BBB8B8" }}
                >
                  Qty
                </div>
              </div>
              <div className="insider-section">
                <div className="insider-header" style={{ color: "#BBB8B8" }}>
                  Approx. Value
                </div>
              </div>
            </div>
            {insiderTransactions.map((obj, i) => (
              <div key={i}>
                {obj[1] !== " " ? (
                  <div
                    className="insider-table"
                    style={{ marginTop: 2, marginBottom: 2 }}
                    key={i}
                  >
                    <div className="insider-section">
                      <div
                        className="insider-header justify-center"
                        style={{
                          color: "#fff",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        {obj[0]}
                      </div>
                    </div>
                    <div className="insider-section">
                      <div className="insider-header justify-center">
                        {obj[1] !== " " ? (
                          <div
                            className={`indicator-pill ${
                              obj[1] < 0 ? "red" : "green"
                            }-background`}
                          >
                            <span style={{ color: "#ffffff" }}>
                              {obj[1] > 0 ? "Buy" : "Sell"}
                            </span>
                          </div>
                        ) : (
                          <div className={`indicator-pill grey-background`}>
                            <span style={{ color: "#666666" }}>- - -</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="insider-section">
                      <div
                        className="insider-header justify-center"
                        style={{ color: "#ffffff" }}
                      >
                        {currency.format(obj[5])}
                      </div>
                    </div>
                    <div className="insider-section">
                      <div
                        className="insider-header justify-center"
                        style={{ color: "#ffffff" }}
                      >
                        {obj[1] !== " " ? number.format(Math.abs(obj[4])) : "0"}
                      </div>
                    </div>
                    <div className="insider-section">
                      <div
                        className="insider-header"
                        // style={{ color: parseFloat(obj[4]) * parseFloat(obj[5]) === 0 ? '#ffffff' : parseFloat(obj[4]) * parseFloat(obj[5]) < 0 ? '#d33541' : '#75ce41' }}
                        style={{ color: "#ffffff" }}
                      >
                        {!isNaN(parseFloat(obj[4]) * parseFloat(obj[5]))
                          ? currency.format(
                              Math.abs(parseFloat(obj[4]) * parseFloat(obj[5])),
                            )
                          : "$0"}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            ))}
          </>
        )}
      </div>
      <div className="section4">
        <div className="correlations-title" style={{ color: "#adaeae" }}>
          USD CORRELATIONS
        </div>

        <div className="trading-text" style={{ color: "#adaeae" }}>
          Correlation Analysis
        </div>
        <div className="week-day-text" style={{ color: "#adaeae" }}>
          <div>52 Week Rolling</div>
          <div>30 Day Correlation</div>
        </div>
        {!data["15"] ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading variant="inner" />
          </div>
        ) : (
          <div className="correlations-table">
            <div className="correlations-column">
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                15D
              </div>
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                30D
              </div>
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                60D
              </div>
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                90D
              </div>
            </div>
            <div className="correlations-column">
              <div
                className={`cell number 
              ${data["15"] ? percentColorVolume(data["15"]) : "empty-value"}`}
              >
                <span>{data["15"] ? data["15"].toFixed(2) : "- - -"}</span>
              </div>
              <div
                className={`cell number 
              ${data["30"] ? percentColorVolume(data["30"]) : "empty-value"}`}
              >
                <span>{data["30"] ? data["30"].toFixed(2) : "- - -"}</span>
              </div>
              <div
                className={`cell number 
              ${data["60"] ? percentColorVolume(data["60"]) : "empty-value"}`}
              >
                <span>{data["60"] ? data["60"].toFixed(2) : "- - -"}</span>
              </div>
              <div
                className={`cell number 
              ${data["90"] ? percentColorVolume(data["90"]) : "empty-value"}`}
              >
                <span>{data["90"] ? data["90"].toFixed(2) : "- - -"}</span>
              </div>
            </div>
            <div className="correlations-column">
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                120D
              </div>
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                180D
              </div>
              <div className="cell grey-text"></div>
            </div>
            <div className="correlations-column">
              <div
                className={`cell number 
              ${data["120"] ? percentColorVolume(data["120"]) : "empty-value"}`}
              >
                <span>{data["120"] ? data["120"].toFixed(2) : "- - -"}</span>
              </div>
              <div
                className={`cell number 
              ${data["180"] ? percentColorVolume(data["180"]) : "empty-value"}`}
              >
                <span>{data["180"] ? data["180"].toFixed(2) : "- - -"}</span>
              </div>
              <div
                className={`cell number ${percentColorVolume(data["15"])}`}
              ></div>
              <div
                className={`cell number ${percentColorVolume(data["15"])}`}
              ></div>
            </div>
            <div className="correlations-column">
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                High
              </div>
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                Low
              </div>
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                %(+)
              </div>
              <div className="cell grey-text" style={{ color: "#BBB8B8" }}>
                %(-)
              </div>
            </div>
            <div className="correlations-column">
              <div
                className={`cell number 
              ${data["max"] ? percentColorVolume(data["max"]) : "empty-value"}`}
              >
                <span>{data["max"] ? data["max"].toFixed(2) : "- - -"}</span>
              </div>
              <div
                className={`cell number 
              ${data["min"] ? percentColorVolume(data["min"]) : "empty-value"}`}
              >
                <span>{data["min"] ? data["min"].toFixed(2) : "- - -"}</span>
              </div>
              <div
                className={`cell number 
              ${
                data["maxchg"]
                  ? percentColorVolume(data["maxchg"])
                  : "empty-value"
              }`}
              >
                <span>
                  {data["maxchg"] ? data["maxchg"].toFixed(2) + "%" : "- - -"}
                </span>
              </div>
              <div
                className={`cell number 
              ${
                data["minchg"]
                  ? percentColorVolume(data["minchg"])
                  : "empty-value"
              }`}
              >
                <span>
                  {data["minchg"] ? data["minchg"].toFixed(2) + "%" : "- - -"}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default React.memo(InsiderAndCorrections);
